<template>
  <div id="SectionBCorpStrategyCall">
    <UIContainer>
      <SectionTitle class="SectionBCorpStrategyCall__title">
        <template #title> Book a B Corp strategy call </template>
        <template #description>
          Select a suitable time a intro call or check Frequently Asked
          Questions below.
        </template>
      </SectionTitle>
      <div
        class="SectionBCorpStrategyCall__calendly"
        ref="calendlyContainer"
        aria-label="Calendly booking widget"
      ></div>
    </UIContainer>
  </div>
</template>

<script setup lang="ts">
import SectionTitle from '@/views/components/misc/SectionTitle.vue'
import UIContainer from '@/views/components/ui/containers/UIContainer/UIContainer.vue'
import { onBeforeUnmount, onMounted, ref } from 'vue'

declare global {
  interface Window {
    Calendly?: {
      initInlineWidget: (options: {
        url: string
        parentElement: HTMLElement
        prefill?: Record<string, unknown>
        utm?: Record<string, unknown>
      }) => void
    }
  }
}

const calendlyContainer = ref<HTMLDivElement | null>(null)
const CALENDLY_URL = 'https://calendly.com/sustainalyse/intro'

function ensureCalendlyStyles(): void {
  const href = 'https://assets.calendly.com/assets/external/widget.css'
  if (!document.querySelector(`link[href="${href}"]`)) {
    const linkEl = document.createElement('link')
    linkEl.rel = 'stylesheet'
    linkEl.href = href
    document.head.appendChild(linkEl)
  }
}

function loadCalendlyScript(): Promise<void> {
  const src = 'https://assets.calendly.com/assets/external/widget.js'
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[src="${src}"]`)) {
      resolve()
      return
    }
    const scriptEl = document.createElement('script')
    scriptEl.src = src
    scriptEl.async = true
    scriptEl.onload = () => resolve()
    scriptEl.onerror = () => reject(new Error('Failed to load Calendly script'))
    document.body.appendChild(scriptEl)
  })
}

onMounted(async () => {
  ensureCalendlyStyles()

  try {
    await loadCalendlyScript()
    if (calendlyContainer.value && window.Calendly) {
      window.Calendly.initInlineWidget({
        url: CALENDLY_URL,
        parentElement: calendlyContainer.value,
      })
    }
  } catch {
    // silently fail; widget will simply not render
  }
})

onBeforeUnmount(() => {
  if (calendlyContainer.value) {
    calendlyContainer.value.innerHTML = ''
  }
})
</script>

<style lang="scss" scoped>
#SectionBCorpStrategyCall {
  .SectionBCorpStrategyCall__title {
    margin: 0 auto 1rem;
  }

  .SectionBCorpStrategyCall__cards {
    margin-top: 4rem; // spacing before cards grid
  }

  .SectionBCorpStrategyCall__calendly {
    position: relative;
    min-width: 320px;
    height: 700px;
  }
}
</style>
